import * as React from 'react';
import { ButtonVariant } from '../button/Shared';
import { FileExtension } from '../../amorg-common';
import { Button } from '../button/Button';
import { Flex } from '../compositeComponents/FlexHelpers';
import { stringUtil } from '../../amorg-common/util/stringUtil';

export function UploadFileSelector(props:{
    id?:string,
    inputName:string,
    selectedFiles?:File[],
    tooltipHorizontalAlignment?: 'left' | 'right',
    fileTypes:FileExtension[],
    disabled?:boolean,
    magnum?:boolean,
    variant?:ButtonVariant,
    multi?:boolean,
    onSelected:(files:File[])=>void
}):JSX.Element
{
    const id = props.id || 'file-uploader';

    const fileInputRef = React.useRef<HTMLInputElement>(null);

    React.useEffect(() =>
    {
        if(props.disabled && fileInputRef.current){
            fileInputRef.current.disabled = true;
        }
    });
    
    async function handleUpload(e:React.ChangeEvent<HTMLInputElement>)
    {
        if(e.target.files?.length > 0){
            await props.onSelected(Array.from(e.target.files));
        }
    }

    return (
        <Flex alignItems='center' gap={8}>
            <Button 
                variant={props.variant || 'outlined'} 
                size={props.magnum ? 'magnum' : undefined}
                icon={'cloud_upload'} 
                disabled={props.disabled}
                tooltipContent={
                    props.selectedFiles && props.selectedFiles.length > 0 
                        ? <Flex flexDirection='column' gap={4}>
                            {props.selectedFiles.map(f => <span key={f.name}>{stringUtil.capTextLength(f.name,24)}</span>)}
                          </Flex>
                        : <span>Ingen fil(er) valgt</span>
                }
                onClick={()=>fileInputRef.current.click()}  />
            <input 
                style={{display:'none'}}
                id={id}
                ref={fileInputRef}
                type="file"
                onChange={handleUpload}
                name={props.inputName} // Must match name used by multer
                accept={props.fileTypes.map(ft => '.'+ft).join(',')}
                disabled={props.disabled}
                multiple={props.multi}
            />
            <Flex>
                {props.selectedFiles && props.selectedFiles.length > 0
                    ? <span style={{fontSize: '14px'}}>{props.selectedFiles.length} fil(er) valgt</span>
                    : <span style={{fontSize: '14px'}}>Ingen fil(er) valgt</span>
                }
            </Flex>

        </Flex>
    );
}